/*
 * Fun-Esports — tiroir « Ajouté au panier » (le thème n'a plus de mini-panier depuis le nouvel en-tête).
 * S'ouvre à chaque ajout au panier (événement product:added du thème), liste les articles
 * (avec le contenu des packs) et met à jour la pastille du panier dans l'en-tête.
 */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var css = '.fe-cd-wrap{position:fixed;inset:0;z-index:2147483000;display:none}.fe-cd-wrap.is-open{display:block}' +
    '.fe-cd-bg{position:absolute;inset:0;background:rgba(17,18,19,.55)}' +
    '.fe-cd-panel{position:absolute;top:0;right:0;height:100%;width:min(420px,100%);background:#fff;box-shadow:-10px 0 30px rgba(0,0,0,.25);display:flex;flex-direction:column;transform:translateX(100%);transition:transform .25s ease}' +
    '.fe-cd-wrap.is-open .fe-cd-panel{transform:none}.fe-cd{display:flex;flex-direction:column;height:100%}' +
    '.fe-cd__head{display:flex;align-items:center;gap:10px;padding:16px 18px;background:#111213;color:#fff;font-weight:700;font-size:16px}' +
    '.fe-cd__ok{display:inline-flex;align-items:center;justify-content:center;width:26px;height:26px;border-radius:50%;background:#00badb;color:#111213}' +
    '.fe-cd__x{margin-left:auto;background:none;border:0;color:#fff;font-size:28px;line-height:1;cursor:pointer}' +
    '.fe-cd__items{flex:1;overflow:auto;padding:6px 18px}.fe-cd__item{display:flex;gap:12px;padding:14px 0;border-bottom:1px solid #e6e6e6}' +
    '.fe-cd__item img{width:72px;height:72px;object-fit:cover;border-radius:8px;flex:0 0 72px}.fe-cd__meta{display:flex;flex-direction:column;gap:3px;font-size:13.5px}' +
    '.fe-cd__t{font-weight:700;color:#111213;text-decoration:none;line-height:1.3}.fe-cd__v{color:#5b6670;font-size:12.5px}.fe-cd__p{font-weight:700;color:#0097ac}' +
    '.fe-cd__foot{padding:14px 18px 18px;border-top:1px solid #e6e6e6;display:flex;flex-direction:column;gap:8px}.fe-cd__sub{display:flex;justify-content:space-between;font-size:16px}' +
    '.fe-cd__ship{margin:0;font-size:12px;color:#5b6670}.fe-cd__btn{display:block;text-align:center;padding:13px;border-radius:8px;border:2px solid #111213;color:#111213;font-weight:700;text-decoration:none}' +
    '.fe-cd__btn--main{background:#111213;color:#fff}.fe-cd__link{background:none;border:0;color:#0097ac;text-decoration:underline;cursor:pointer;font-size:13.5px;padding:4px}' +
    '.fe-pack-parts{margin:4px 0 2px;padding:7px 9px;background:#f2fbfd;border-left:3px solid #00badb;border-radius:4px;font-size:12.5px}' +
    '.fe-pack-parts__lbl{display:block;font-weight:700;margin-bottom:3px}.fe-pack-parts ul{list-style:none;margin:0;padding:0}' +
    '.fe-pack-parts li{display:flex;align-items:center;gap:7px;margin:3px 0}.fe-pack-parts img{width:32px;height:32px;object-fit:cover;border-radius:4px}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var wrap;
  function ensure() {
    if (wrap) return wrap;
    wrap = document.createElement('div'); wrap.className = 'fe-cd-wrap';
    wrap.innerHTML = '<div class="fe-cd-bg" data-fe-cd-close></div><div class="fe-cd-panel" role="dialog" aria-modal="true"></div>';
    document.body.appendChild(wrap);
    wrap.addEventListener('click', function (e) { if (e.target.closest('[data-fe-cd-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    return wrap;
  }
  function close() { if (wrap) { wrap.classList.remove('is-open'); document.documentElement.style.overflow = ''; } }
  function setCount(n) {
    document.querySelectorAll('a.iconbtn[href$="/cart"], a.iconbtn[href*="/cart"]').forEach(function (a) {
      var d = a.querySelector('.dot');
      if (n > 0) { if (!d) { d = document.createElement('span'); d.className = 'dot'; a.appendChild(d); } d.textContent = n; }
      else if (d) d.remove();
    });
  }
  function open() {
    ensure();
    fetch(root + 'cart?section_id=fe-cart-drawer', { credentials: 'same-origin', headers: { 'Cache-Control': 'no-cache' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var box = tmp.querySelector('.fe-cd'); if (!box) { window.location.href = root + 'cart'; return; }
        wrap.querySelector('.fe-cd-panel').innerHTML = ''; wrap.querySelector('.fe-cd-panel').appendChild(box);
        setCount(parseInt(box.getAttribute('data-count') || '0', 10));
        wrap.classList.add('is-open'); document.documentElement.style.overflow = 'hidden';
      })
      .catch(function () { window.location.href = root + 'cart'; });
  }
  window.FECartDrawer = { open: open, close: close };
  document.addEventListener('product:added', function (e) {
    if (e.detail && e.detail.productAdded === false) return;
    if (window.theme && window.theme.pageType === 'cart') return;
    open();
  });
})();

/* Page panier : affiche « Ce pack contient » sous chaque ligne de pack. */
(function () {
  if (!(window.theme && window.theme.pageType === 'cart')) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false, last = '';
  function inject() {
    if (busy) return; busy = true;
    fetch(root + 'cart?section_id=fe-cart-parts', { credentials: 'same-origin', headers: { 'Cache-Control': 'no-cache' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var rows = document.querySelectorAll('tr.fe-cart__row, tr.line-item');
        rows.forEach(function (row, i) {
          var src = tmp.querySelector('[data-line="' + (i + 1) + '"] .fe-pack-parts');
          var meta = row.querySelector('.fe-cart__meta, .line-item__meta');
          if (!meta) return;
          var old = meta.querySelector('.fe-pack-parts'); if (old) old.remove();
          if (!src) return;
          var anchor = meta.querySelector('.fe-cart__variant') || meta.querySelector('.line-item__title');
          if (anchor) anchor.insertAdjacentElement('afterend', src.cloneNode(true)); else meta.appendChild(src.cloneNode(true));
        });
      })
      .finally(function () { busy = false; });
  }
  function sig() { return Array.prototype.map.call(document.querySelectorAll('tr.fe-cart__row, tr.line-item'), function (r) { return r.textContent.length; }).join(','); }
  document.addEventListener('DOMContentLoaded', inject);
  if (document.readyState !== 'loading') inject();
  new MutationObserver(function () {
    var s = sig(); var missing = document.querySelectorAll('tr.fe-cart__row .fe-pack-parts, tr.line-item .fe-pack-parts').length === 0;
    if (s !== last) { last = s; if (missing) setTimeout(inject, 50); }
  }).observe(document.body, { childList: true, subtree: true });
})();
